'use strict';
import React from 'react';
import flux from 'utils/flux';
import { Navigation } from 'react-router';
import Immutable from 'immutable';
import store from 'store';

var HeaderBarBasket = React.createClass({
    displayName: 'HeaderBarBasket',
    mixins: [
        Navigation
    ],
    propTypes: {
        basket: React.PropTypes.object.isRequired
    },
    _getSelectedBasketIds() {
        return this._getSelectedBaskets().map( basket => basket.get('id') );
    },
    _getSelectedBaskets() {
        return this.props.baskets.filter( basket => basket.get('isSelected') );
    },
    deleteBaskets(e) {
        e.preventDefault();
        var baskets = this._getSelectedBaskets();
        var basketIdsToDelete = baskets.map((basket) => basket.get('id'));
        var basketNamesToDelete = baskets.map((basket) => basket.get('name')).toJS();

        flux.getActions('modals').confirmModal({
            title: flux.t('delete_folder'),
            basketNames: basketNamesToDelete,
            onConfirm: () => {
                flux.getStore('basket').deleteBaskets( basketIdsToDelete ).then(() => {
                    const gotToBasket = this.props.baskets.first();
                    if ( gotToBasket ) {
                        this.transitionTo( 'singleBasket', { id: gotToBasket.get('id') } );
                    }
                    else {
                        this.transitionTo( 'basket' );
                    }
                    flux.getActions('modals').closeModals();
                });
            }
        });
    },
    shareBaskets() {
        var basketIdsToShare = this._getSelectedBasketIds();

        flux.getActions('modals').openModal('Share');
        flux.getStore('basket').shareBaskets(basketIdsToShare);
    },
    toggleCheckAll(size, e) {
        e.preventDefault();
        flux.getActions('basket').toggleDownloadAll(size);
    },
    handleDownloadSubmit(e) {
        e.preventDefault();
        let itemsToDownload = flux.getStore('basket').getItemsToDownload( this.props.basket.get('items').toJS() );
        let params = {};
        itemsToDownload.forEach( item => params[item.id] = item.size );

        flux.getStore('media').checkQuota( params ).then( response => {
            const { quotaExceeded } = flux.getStore('media').getState();

            if ( quotaExceeded ) {
                return;
            }

            this.refs.download.getDOMNode().submit();

            itemsToDownload = itemsToDownload.map( item => item.id );
            const items = this.props.basket.get('items').toJS();
            const watermarks = Immutable.List( itemsToDownload.map( id => items.find( item => id === item.id ) ).filter( item =>  item.requires_watermark ) );
            if ( watermarks.size ) {
                flux.getActions('modals').openWatermarkModal( watermarks );
            }
        });
    },
    render() {
        if (!this.props.baskets || !this.props.basket || this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
            return false;
        }
        var itemsToDownload = flux.getStore('basket').getItemsToDownload(this.props.basket.get('items').toJS());
        var selectedBaskets = this._getSelectedBaskets();
        var mediaboxToken = store.get('mediabox_token');
        const { quotaExceeded } = flux.getStore('media').getState();

        return (
            <div className="headerbar--basket">
                <div className="headerbar__actions">
                    <button onClick={this.deleteBaskets} disabled={selectedBaskets.size === 0} className="btn btn-border btn-remove">
                        <i className="gopro-close-small"></i>
                        {flux.t('remove_baskets')}
                    </button>

                    <button onClick={this.shareBaskets} disabled={selectedBaskets.size === 0} className="btn btn-border btn-share">
                        <i className="gopro-share"></i>
                        {flux.t('share_baskets')}
                    </button>
                </div>
                <div className="headerbar__selection">
                    <span className="selection__title">
                        {flux.t('select_all')}:
                    </span>

                    <div className="selection__actions">
                        <form>
                            {this.props.basket.get('_filenames').toJS().map((file, ix) => {
                                return (
                                    <div key={'basket_size_'+ix} className="field__checkbox download__checkbox">
                                        <input id="check__all" checked={flux.getStore('basket').fileIsChecked(this.props.basket, file.name)} type="checkbox" readOnly />
                                        <label onClick={this.toggleCheckAll.bind(null, file.name)} htmlFor="check__all">{file.name}</label>
                                    </div>
                                );
                            })}
                        </form>
                        <form ref="download" onSubmit={this.handleDownloadSubmit} action={window.config.baseUrl + '/basket/' + this.props.basket.get('id') + '/download'}>
                          <input type="hidden" name="token" value={mediaboxToken} />
                            {itemsToDownload.map( (item, ix) => {
                                return (<input key={'input_' + ix} type="hidden" name={item.id} value={item.size} />);
                            })}
                            <button type="submit" disabled={itemsToDownload.length === 0 || quotaExceeded} className="btn btn-border selection__download">
                                <i className="gopro-download" />
                                {flux.t('download')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = HeaderBarBasket;



// WEBPACK FOOTER //
// ./app/components/headerBar/headerBasket.jsx